import { Loader } from "./overrides/LoaderPlugin";
import MusicManager from "./MusicManager";
import F84Game from "../Game";
import { GameObjectFactory } from "./overrides/GameObjectFactoryPlugin";
import LoadBatchManager from "./LoadBatchManager";
import SoundManager from "./SoundManager";

export default class Scene extends Phaser.Scene {
	public add: GameObjectFactory;
	public load: Loader;
	public get music(): MusicManager {
		return (<F84Game>this.game).music;
	}
	public get soundManager(): SoundManager {
		return (<F84Game>this.game).soundManager;
	}
	public get loadBatches(): LoadBatchManager {
		return (<F84Game>this.game).loadBatches;
	}
	public get alignIn(): typeof Phaser.Display.Align.In {
		return Phaser.Display.Align.In;
	}
	public get alignTo(): typeof Phaser.Display.Align.To {
		return Phaser.Display.Align.To;
	}
}
